export default __webpack_public_path__ + "static/media/tv.a1651a79.svg";